module.exports = __webpack_public_path__ + "static/assets/f61308b22b8c5a30095558cf6ff3b122.svg";